import { EuiButton, EuiButtonEmpty, useEuiTheme } from "@elastic/eui";
import { ReactElement } from "react";
import { createUseStyles } from "react-jss";
import { button_styles } from "styles/components/button/button_styles";

const buttonStyles = createUseStyles(button_styles);

interface ButtonProps {
  onClick: (any: any) => any;
  type: "primary" | "secondary" | "back" | "next" | "empty" | "ask";
  text: string | ReactElement;
  disabled?: boolean;
  isLoading?: boolean;
  iconType?: any;
  iconSide?: "left" | "right";
  style?: any;
  className?: any;
  askType?: "card" | "table" | string | undefined;
}

const Button = ({
  onClick,
  text,
  type,
  disabled = false,
  isLoading = false,
  iconType,
  iconSide = "left",
  style,
  askType = "card",
}: ButtonProps) => {
  const theme = useEuiTheme();
  const classes = buttonStyles({ askType, theme });

  if (type === "primary") {
    return (
      <EuiButton
        disabled={disabled}
        className={disabled ? classes.disabled : classes.button}
        fill
        isLoading={isLoading}
        minWidth={false}
        onClick={onClick}
        size="s"
        iconSide={iconSide}
        {...(style && { style })}
        {...(iconType && { iconType })}>
        {text}
      </EuiButton>
    );
  }

  if (type === "secondary") {
    return (
      <EuiButtonEmpty
        size="s"
        className={disabled ? classes.disabled : classes.secondary}
        onClick={onClick}
        {...(iconType && { iconType })}
        iconSide={iconSide}
        {...(style && { style })}
        disabled={disabled}
        isLoading={isLoading}>
        {text}
      </EuiButtonEmpty>
    );
  }

  if (type === "empty") {
    return (
      <EuiButtonEmpty
        size="s"
        className={disabled ? classes.disabled : classes.empty}
        onClick={onClick}
        {...(style && { style })}
        disabled={disabled}
        isLoading={isLoading}
        iconSide={iconSide}
        {...(iconType && { iconType })}>
        {text}
      </EuiButtonEmpty>
    );
  }

  if (type === "back") {
    return (
      <EuiButtonEmpty
        size="s"
        className={disabled ? classes.disabled : classes.empty}
        {...(style && { style })}
        onClick={onClick}
        disabled={disabled}
        iconType="arrowLeft"
        iconSide="left">
        {text ?? "Back"}
      </EuiButtonEmpty>
    );
  }

  if (type === "next") {
    return (
      <EuiButtonEmpty
        size="s"
        className={disabled ? classes.disabled : classes.empty}
        {...(style && { style })}
        onClick={onClick}
        disabled={disabled}
        iconType="arrowRight"
        iconSide="right">
        {text ?? "Next"}
      </EuiButtonEmpty>
    );
  }

  if (type === "ask") {
    return (
      <EuiButtonEmpty
        size="xs"
        style={{ padding: "4px 14px" }}
        {...(style && { style })}
        className={disabled ? classes.disabled : classes.ask_button}
        onClick={onClick}
        {...(iconType && { iconType })}
        {...(iconSide && { iconSide })}
        disabled={disabled}>
        {text ?? "Ask Advisor"}
      </EuiButtonEmpty>
    );
  }
};

export default Button;
